import { DisconnectLinkedinMeta, DisconnectLinkedinPayload } from 'types/store/DisconnectLinkedin';
import { createAsyncReducer } from 'utils/Redux';

import { disconnectLinkedinActions } from '../actions';

export default createAsyncReducer<DisconnectLinkedinMeta, DisconnectLinkedinPayload>(disconnectLinkedinActions);
